'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonSections = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _nuiIntl = require('@concur/nui-intl');

var _reactRedux = require('react-redux');

var _AppCategory = require('../listings/AppCategory');

var _AppCategory2 = _interopRequireDefault(_AppCategory);

var _LoadingIndicator = require('../shared/LoadingIndicator');

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _listingsModule = require('../listings/listingsModule');

var ListingsActions = _interopRequireWildcard(_listingsModule);

var _utils = require('../utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// let SEED = Date.now();
// function random() {
//   const x = Math.sin(SEED++) * 10000;
//   return x - Math.floor(x);
// }

var CommonSections = function (_React$Component) {
  _inherits(CommonSections, _React$Component);

  function CommonSections() {
    _classCallCheck(this, CommonSections);

    return _possibleConstructorReturn(this, (CommonSections.__proto__ || Object.getPrototypeOf(CommonSections)).apply(this, arguments));
  }

  _createClass(CommonSections, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this.setState({ isLoaded: true });

      if ((0, _utils.canUseDOM)() && this.props.listings.listingsReadyState !== ListingsActions.LISTINGS_FETCHED) {
        window.setTimeout(function () {
          _this2.setState({
            isLoaded: _this2.props.listings.listingsReadyState === ListingsActions.LISTINGS_FETCHED
          });
        }, 700);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        isLoaded: nextProps.listings.listingsReadyState === ListingsActions.LISTINGS_FETCHED
      });
    }
  }, {
    key: 'renderNoResults',
    value: function renderNoResults() {
      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12', id: 'popular-collection' },
          _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'NoSearchResults' })
        )
      );
    }
  }, {
    key: 'buildCollectionSet',
    value: function buildCollectionSet(popularListings, popularForEnterprise, allListingsSection, nonshuffledAllListingsSection, partitionedAllApps) {
      var listings = this.props.listings;
      var MIN_APP_NUM = 20;
      var MIN_NUM_LISTINGS = allListingsSection.length >= MIN_APP_NUM;

      var chooseEnterpriseTitle = function chooseEnterpriseTitle(categoryDescription) {
        if (!listings.category || listings.category.slug === 'all') {
          return _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'EnterpriseAppsCollection' });
        }
        return _react2.default.createElement(_nuiIntl.FormattedMessage, {
          id: 'CategoryForEnterprise',
          values: { category: categoryDescription }
        });
      };

      var choosePopularForCategoryTitle = function choosePopularForCategoryTitle(categoryDescription) {
        if (!listings.category || listings.category.slug === 'all') {
          return _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'PopularConnectionsCollection' });
        }
        return _react2.default.createElement(_nuiIntl.FormattedMessage, {
          id: 'PopularForCategoryCollection',
          values: { category: categoryDescription }
        });
      };

      var chooseAllCategoryTitle = function chooseAllCategoryTitle(categoryDescription) {
        if (!listings.category || listings.category.slug === 'all') {
          return MIN_NUM_LISTINGS ? _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'AllAppsCollection' }) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Connections' });
        }
        return MIN_NUM_LISTINGS ? _react2.default.createElement(_nuiIntl.FormattedMessage, {
          id: 'AllForCategoryCollection',
          values: { category: categoryDescription }
        }) : _react2.default.createElement(_nuiIntl.FormattedMessage, {
          id: 'ConnectionsForCategory',
          values: { category: categoryDescription }
        });
      };

      if (!popularListings.length && !popularForEnterprise.length && !allListingsSection.length) {
        return this.renderNoResults();
      }

      var categoryDescription = listings.category ? listings.category.description : '';
      // we don't want two collections showing the same listings
      if ((!popularListings.length || !popularForEnterprise.length) && popularListings.length < 10 && popularForEnterprise.length < 10) {
        return _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12', id: 'all-listings' },
            _react2.default.createElement(_AppCategory2.default, {
              categoryTitle: chooseAllCategoryTitle(categoryDescription),
              categorySubtitle: _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'AllAppsCollectionSubtitle' }),
              listings: partitionedAllApps,
              isLoggedIn: this.props.userPrefs.isLoggedIn,
              windowWidth: window.innerWidth
            })
          )
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        MIN_NUM_LISTINGS && _react2.default.createElement(
          'div',
          { id: 'popular-section', className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12', id: 'popular-collection' },
            _react2.default.createElement(_AppCategory2.default, {
              categoryTitle: choosePopularForCategoryTitle(categoryDescription),
              categorySubtitle: _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'PopularConnsCollectionSubtitle' }),
              listings: popularListings,
              isLoggedIn: this.props.userPrefs.isLoggedIn,
              windowWidth: window.innerWidth
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12', id: 'popular-for-enterprise' },
            _react2.default.createElement(_AppCategory2.default, {
              categoryTitle: chooseEnterpriseTitle(categoryDescription),
              categorySubtitle: _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'EnterpriseAppsCollectionSubtitle' }),
              listings: popularForEnterprise,
              isLoggedIn: this.props.userPrefs.isLoggedIn,
              windowWidth: window.innerWidth
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { id: 'connections-section', className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12', id: 'all-listings' },
            _react2.default.createElement(_AppCategory2.default, {
              categoryTitle: chooseAllCategoryTitle(categoryDescription),
              categorySubtitle: _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'AllAppsCollectionSubtitle' }),
              listings: MIN_NUM_LISTINGS ? allListingsSection : nonshuffledAllListingsSection,
              isLoggedIn: this.props.userPrefs.isLoggedIn,
              windowWidth: window.innerWidth
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$listings = this.props.listings,
          readyState = _props$listings.readyState,
          filtered = _props$listings.filtered;


      if (readyState === ListingsActions.LISTINGS_FETCH_FAILED) {
        return _react2.default.createElement(
          'p',
          null,
          'Failed to fetch Listings'
        );
      }

      function prioritySort(a, b) {
        if (a.core.priority < b.core.priority) return -1;else if (a.core.priority > b.core.priority) return 1;
        return 0;
      }

      var partitionedListings = _lodash2.default.partition(filtered.concat([]).sort(prioritySort), function (listing) {
        return !listing.core.listingDisabled;
      });

      var partitionedAllApps = _lodash2.default.flatten(partitionedListings);

      var popularListings = _lodash2.default.chain(partitionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'USER';
      }).take(10).value();

      var popularForEnterprise = _lodash2.default.chain(partitionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'ADMIN';
      }).sort(prioritySort).value();

      var shuffledPartionedAllApps = _lodash2.default.shuffle(partitionedListings[0]).concat(_lodash2.default.shuffle(partitionedListings[1]));

      var nonshuffledAllListingsSection = _lodash2.default.chain(partitionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'USER';
      }).value();

      var allListingsSection = _lodash2.default.chain(shuffledPartionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'USER';
      }).value();

      return _react2.default.createElement(
        'div',
        { style: { minHeight: '1151px' } },
        _react2.default.createElement(
          _LoadingIndicator2.default,
          { isLoaded: this.state.isLoaded },
          this.buildCollectionSet(popularListings, popularForEnterprise, allListingsSection, nonshuffledAllListingsSection, partitionedAllApps)
        )
      );
    }
  }]);

  return CommonSections;
}(_react2.default.Component);

CommonSections.propTypes = {
  listings: _propTypes2.default.object,
  user: _propTypes2.default.object,
  userPrefs: _propTypes2.default.shape({
    isLoggedIn: _propTypes2.default.bool
  })
};

function mapStateToProps(state) {
  return {
    listings: state.listings,
    user: state.user,
    userPrefs: state.userPrefs
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CommonSections);
exports.CommonSections = CommonSections;


//////////////////
// WEBPACK FOOTER
// ./lib/shared/CommonSections.js
// module id = 200
// module chunks = 0